import { render, staticRenderFns } from "./Section.vue?vue&type=template&id=1ca9cbc0&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Section: require('/opt/build/repo/components/common/Section.vue').default})
